"use client";

import { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { CategorySearch } from "@/components/dashboard/category-search";
import { ThemeToggle } from "@/components/layout/theme-toggle";

const navLinks = [
  { name: "Dashboard", href: "/dashboard" },
  { name: "Top Opportunities", href: "/dashboard/opportunities" },
  { name: "Tools", href: "/dashboard/tools" },
  { name: "Research", href: "/research" },
  { name: "Metrics", href: "/dashboard/metrics" }
];

function MenuIcon({ open }: { open: boolean }) {
  if (open) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    );
  }
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  );
}

export function DashboardNavbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const pathname = usePathname();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <div className="dashboard-navbar-wrap">
      <nav className="dashboard-navbar">
        {/* Desktop & Tablet */}
        <div className="dashboard-navbar-desktop">
          <Link href="/" className="dashboard-navbar-brand">
            <Image
              src="/logo.png"
              alt="NicheMRR"
              width={140}
              height={36}
              className="brand-logo"
              priority
            />
            <span className="dashboard-navbar-brand-name">NicheMRR</span>
          </Link>
          <div className="dashboard-navbar-links">
            {navLinks.map((link) => {
              const isActive = pathname === link.href;
              return (
                <Link
                  key={link.name}
                  href={link.href}
                  className={`dashboard-navbar-link ${isActive ? "dashboard-navbar-link--active" : ""}`}
                >
                  {link.name}
                </Link>
              );
            })}
          </div>
          <CategorySearch />
          <ThemeToggle />
          <button
            type="button"
            onClick={toggleMenu}
            className="dashboard-navbar-menu-btn"
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          >
            <MenuIcon open={isMenuOpen} />
          </button>
        </div>

        {/* Mobile */}
        <div className="dashboard-navbar-mobile">
          <Link href="/" className="dashboard-navbar-brand">
            <Image
              src="/logo.png"
              alt="NicheMRR"
              width={140}
              height={36}
              className="brand-logo"
              priority
            />
          </Link>
          <div className="dashboard-navbar-mobile-search">
            <CategorySearch />
          </div>
          <ThemeToggle />
          <button
            type="button"
            onClick={toggleMenu}
            className="dashboard-navbar-menu-btn"
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          >
            <MenuIcon open={isMenuOpen} />
          </button>
        </div>
      </nav>

      {/* Mobile Accordion Menu */}
      <div
        className={`dashboard-navbar-accordion ${isMenuOpen ? "dashboard-navbar-accordion--open" : ""}`}
      >
        <div className="dashboard-navbar-accordion-inner">
          {navLinks.map((link) => {
            const isActive = pathname === link.href;
            return (
              <Link
                key={link.name}
                href={link.href}
                className={`dashboard-navbar-accordion-link ${isActive ? "dashboard-navbar-accordion-link--active" : ""}`}
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
